import { Leaves } from '@common/types';
import { useBi } from './useBi';
import { marketplaceHeaderClientGenericClick } from '@wix/bi-logger-marketplace/v2';
import { useCallback } from 'react';

export const BI_CLICK_TYPES = {
  mobileMenu: 'mobile menu',
  profileDropdownMenu: 'click in profile drop down menu',
  wixMarketplace: 'wix marketplace',
  sellInMarketplace: 'sell in marketplace',
  sellInMarketplaceOfferServices: 'sell in the marketplace - offer services',
  sellInMarketplaceSellStudioTemplates:
    'sell in the marketplace - sell studio templates',
  applyToMarketplace: 'apply to marketplace',
} as const;

export const BI_CLICK_DATA = {
  myProjects: 'my projects',
  contactSupport: 'contact support',
  goToWix: 'go to wix',
  getHired: 'get hired',
  changeLanguage: 'change language',
} as const;

export type IBIClickTypes = Leaves<typeof BI_CLICK_TYPES>;

export const PAGE_NAMES = {
  profile: 'profile page',
  brief: 'brief',
  explore: 'explore',
  notFound: 'not found page',
  templates: 'templates',
  clientProjects: 'client projects',
  projectNotFound: 'project not found',
} as const;

export type IMPHeaderPageName = Leaves<typeof PAGE_NAMES>;

interface IUseMarketplaceHeaderBiParams {
  pageName: IMPHeaderPageName;
}

interface IReportClickParams {
  clickType: IBIClickTypes;
  clickData?: any;
}

const useMarketplaceHeaderBi = ({
  pageName,
}: IUseMarketplaceHeaderBiParams) => {
  const logger = useBi();

  const reportClick = useCallback(
    ({ clickType, clickData }: IReportClickParams) => {
      logger.report(
        marketplaceHeaderClientGenericClick({
          clickType,
          click_data: clickData,
          pageName,
        }),
      );
    },
    [marketplaceHeaderClientGenericClick, pageName],
  );

  return {
    reportClick,
  };
};

export default useMarketplaceHeaderBi;
